export class MfaModel {
    public mfaKey: number;

   
 }
 
 export class MultifactorAuthenticationModel extends MfaModel{
    
 }
 